import type { AppMessages } from "@/i18n/ja";
import { createList } from "./createList";

interface BasicsHelpSubsectionMessages {
  readonly heading: string;
  readonly description: string;
  readonly items: readonly string[];
}

interface BasicsSystemMessages {
  readonly heading: string;
  readonly pcDescription: string;
  readonly mobileDescription: string;
}

export function renderBasicsPanel(
  container: HTMLElement,
  isTouchPrimary: boolean,
  messages: AppMessages,
): void {
  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = isTouchPrimary
    ? messages.help.basics.mobileDescription
    : messages.help.basics.pcDescription;

  const list = createList(messages.help.basics.items);

  const sections = [
    ...(isTouchPrimary
      ? [createBasicsHelpSubsection(messages.help.basics.virtualPointer)]
      : []),
    createBasicsHelpSubsection(messages.help.basics.offline),
    createBasicsSystemSection(messages.help.basics.system, isTouchPrimary),
  ];

  container.replaceChildren(description, list, ...sections);
}

function createBasicsHelpSubsection(
  messages: BasicsHelpSubsectionMessages,
): HTMLElement {
  const section = document.createElement("section");
  section.className = "hover-idle-help-subsection";

  const heading = document.createElement("h3");
  heading.className = "hover-idle-help-subtitle";
  heading.textContent = messages.heading;

  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = messages.description;

  section.append(heading, description, createList(messages.items));
  return section;
}

function createBasicsSystemSection(
  messages: BasicsSystemMessages,
  isTouchPrimary: boolean,
): HTMLElement {
  const section = document.createElement("section");
  section.className = "hover-idle-help-subsection";

  const heading = document.createElement("h3");
  heading.className = "hover-idle-help-subtitle";
  heading.textContent = messages.heading;

  const description = document.createElement("p");
  description.className = "hover-idle-help-body";
  description.textContent = isTouchPrimary
    ? messages.mobileDescription
    : messages.pcDescription;

  section.append(heading, description);
  return section;
}
